import {error,notify} from "../../utils/log";
import {OrderType, OrderDuration, AssetType, OrderAction, DebitCredit, PositionEffect, OrderClass} from '../../domain/types';
import {Order} from "../../domain/Order";
import QuoteService from '../../services/Quotes'
import {OrderBus, OrderMessages} from '../../services/EventBus'
import TradingBlockRemote from '@/services/TradingBlockRemote'

const state = () => ({
    show_window: false,
    quote0: null,
    quote1: null,
    tried: false,
    busy: false,
    placing: false,
    xhr: null,
    order: {
        Legs: [
            {
                AssetType: AssetType.Undefined,
                PositionEffect: PositionEffect.Open,
                SpreadRatio: null,
                Action: OrderAction.Buy
            }],
            Quantity: 0,
            OrderType: OrderType.Limit, OrderClass: OrderClass.Single, Duration: OrderDuration.Day,
            AccountId: null, SubaccountId: null, Price: 0, Stop: 0, fixed: false
      },
});

export default {
  namespaced: true,
  state,
  mutations:{

      SET_PRICE(state, payload){
          state.order = {...state.order, Price: payload};
      },
      SET_STOP(state, payload){
          state.order = {...state.order, Stop: payload};
      },
      SET_SPREAD(state, payload){
          if (payload){

              state.order.Legs = [
                  {...state.order.Legs[0], SpreadRatio: 1, AssetType: AssetType.Option},
                  {...state.order.Legs[0], SpreadRatio: 1, AssetType: AssetType.Option}
              ]
          } else {
              delete state.order.Legs[0].SpreadRatio;
              if (state.order.Legs[1])
                delete state.order.Legs[1].SpreadRatio;
          }
      },
      SET_DEBIT(state){
         state.order = {...state.order, DebitCredit: DebitCredit.Debit};
      },
      SET_CREDIT(state){
          state.order = {...state.order, DebitCredit: DebitCredit.Credit};
      },
      SET_QUANTITY(state, payload){
          state.order = {...state.order, Quantity: payload};
      },
      SET_DURATION(state, payload){
          state.order = {...state.order, Duration: payload};
      },

  },
  actions:{
      SetOrderType({state,dispatch}, payload){
          dispatch('addPriceFields', payload);
          state.order.OrderType = payload;
      },
      setUnderlying({state}, payload){
        state.order.UnderlyingSymbol = payload;
      },
      selectOrderAction({state}, v) {
          state.order.Legs[0].Action = v;
      },
      addPriceFields({state}, payload) {

          switch (payload) {
              case OrderType.Market:
                  break;
              case OrderType.MarketOnClose:
                  break;
              case OrderType.Limit:
                  if (isNaN(state.Price) || state.Price==0)
                      state.Price = (state.quote0 && state.quote0.LastTradePrice )?
                          state.quote0.LastTradePrice: 0;
                  break;
              case OrderType.StopMarket:
                  if (isNaN(state.Stop) || state.Stop==0)
                      state.Stop = (state.quote0 && state.quote0.LastTradePrice )?
                          state.quote0.LastTradePrice: 0;
                  break;
              case OrderType.StopLimit:
                  if (isNaN(state.Price) || state.Price==0) {
                      state.Price = (state.quote0 && state.quote0.LastTradePrice )?
                          state.quote0.LastTradePrice: 0;

                  }
                  if (isNaN(state.Stop)) state.order.Stop = 0;
                  break;
          }
      },

      HIDE_TRADE_WINDOW({state}){
          state.show_window = false;
      },
      async SET_ORDER({state, dispatch}, payload){
          let order = payload;
          console.log("SET_ORDER"+payload);
          if (!order) throw new Error("bad order");

          state.order = {...order};
          state.quote0 = null;
          state.quote1 = null;
          if (!state.order.Price) state.order.Price = 0;
          if (!state.order.Stop) state.order.Stop = 0;

          state.OrderType = OrderType.Unknown;
          if (isNaN(order.Quantity)) state.order.Quantity = 0;
          if (isNaN(order.Legs[0].PositionEffect)||order.Legs[0].PositionEffect===PositionEffect.Unknown) state.order.Legs[0].PositionEffect = PositionEffect.Open;
          if (isNaN(order.Legs[0].Action)||order.Legs[0].Action===0) state.order.Legs[0].Action = OrderAction.Buy;
          if (isNaN(order.Duration)||order.Duration===0) state.order.Duration = OrderDuration.Day;
          if (isNaN(order.OrderClass)) state.order.OrderClass = OrderClass.Single;

          await dispatch('updateQuote0');
          //state.addPriceFields(state.order.OrderType);
          if (isNaN(order.OrderType) || order.OrderType===OrderType.Unknown)
              dispatch('addPriceFields',OrderType.Limit);
          else
              dispatch('addPriceFields',order.OrderType);

          state.tried = false;
      },
      reset({state}){
          delete state.order.selectrecent;
          state.tried = false;
          Order.reset( state.order);
          state.order = {... state.order};
      },
      async makeSingleOption({state, commit, dispatch}) {
          dispatch('reset');
          await dispatch('loadSftSymbol', null,{root:true});
          commit('SET_SPREAD', false);

          state.order.fixed = false;
          state.order.OrderClass = 1;
          state.order.OrderType = OrderType.Limit;
          state.order.DurationId = OrderDuration.Day;
          state.order.Legs.splice(1, 1);
          state.order.Legs[0].AssetType = 2;
          state.quote0 = null;
      },
      async setSingleEntity({state, commit, dispatch}) {
          dispatch('reset');

          commit('SET_SPREAD', false);

          state.order.fixed = false;
          state.order.OrderClass = 1;
          state.order.Legs.splice(1, 1);
          dispatch('selectOrderAction',OrderAction.Buy);
          state.order.OrderType = OrderType.Limit;
          state.order.DurationId = OrderDuration.Day;
          state.order.Legs[0].AssetType = 1;
          state.order.Legs[0].Symbol = state.order.UnderlyingSymbol;
          await dispatch('updateQuote0');
          dispatch('addPriceFields');

      },
      async setSpread({state, commit, dispatch}){
          dispatch('reset');
          await dispatch('loadSftSymbol', null,{root:true});
          commit('SET_SPREAD', true);

          state.order.fixed = false;
          state.order.Legs[0].SpreadRatio = 1;
          state.order.Legs[0].AssetType = 2;
          state.order.Legs[1] = {...state.order.Legs[0], SpreadRatio : 1};
          state.order.DebitCredit = DebitCredit.Debit;
          state.order = {...state.order, OrderClass : OrderClass.Spread }

      },
      async setLeg0({state, dispatch}, payload){

          let {field, val} = payload;
          if (field==="Symbol") {
              await dispatch('updateQuote0');
              dispatch('addPriceFields');
          }
          state.order.Legs[0][field] = val;
          state.order = {...state.order};

      },
      async setLeg1({state, dispatch}, payload){
          let {field, val} = payload;

          if (field==="Symbol") {
              await dispatch('updateQuote1');
              dispatch('addPriceFields');
          }
          state.order.Legs[1][field] = val;
          state.order = {...state.order};
      },
      async setOptionLeg0({state, dispatch}, payload) {

          dispatch('updateQuote0');
          state.order.Legs[0].Symbol = payload;
      },
      async setOptionLeg1({state, dispatch}, payload) {

          dispatch('updateQuote1');
          state.order.Legs[1].Symbol = payload;
      },
      async updateQuote0({state}) {
          state.quote0 = null;
          state.busy = true;


              const resp = await QuoteService.loadFromTradingBlock([state.order.Legs[0].Symbol]);


              if (resp && resp[0]) {
                  state.quote0 = resp[0];
                  state.Price = state.quote0.LastTradePrice;
                  state.order.Price = state.quote0.LastTradePrice;
              }
              state.busy = false;

      },
      async updateQuote1({state}) {
          state.quote1 = null;


          const resp = await QuoteService.loadFromTradingBlock([state.order.Legs[1].Symbol]);

              if (resp && resp[0])
                  state.quote1 = resp[0];

      },
      checkAndSubmit({getters, state, dispatch}) {
          if (state.busy) return;
          if (!state.tried) state.tried = true;
          if (getters.InvalidOrder) return;

          let order = {...state.order};
          delete order.fixed;
          delete order.OrderId;
          state.placing = true;
          if (order.OrderType==OrderType.Market || order.OrderType==OrderType.MarketOnClose) {
              delete order.Price; delete order.Stop;
          }
          if (order.OrderType==OrderType.Limit) {
              order.Price = order.Price.toFixed(2);
              delete  order.Stop;
          }
          if (order.OrderType==OrderType.StopMarket){
              order.Stop = order.Stop.toFixed(2);
              delete order.Price;
          }
          if (order.OrderType==OrderType.StopLimit) {
              order.Price = order.Price.toFixed(2);
              order.Stop = order.Stop.toFixed(2);
          }
          if (order.OrderClass!=OrderClass.Spread){
              delete order.DebitCredit;
              delete order.Legs[0].SpreadRatio;
          } else {
              order.Legs[0].SpreadRatio = 1;
              order.Legs[1].SpreadRatio = 1;
          }

          order.SubaccountId = TradingBlockRemote.SubaccountId;
          order.AccountId = TradingBlockRemote.AccountId;
          state.xhr = new TradingBlockRemote({
              onComplete: () => dispatch('onPlaceSuccess'),
              onFailure: () => dispatch('onPlaceFailure')
          }).PlaceOrder(order);
      },
      onPlaceSuccess(id){
          state.placing = false;
          setTimeout(
              ()=>{OrderBus.$emit(OrderMessages.OrderAdded, state.order);
              }, 2000 );


          notify.log("Place success for order "+id.OrderId)
      },
      onPlaceFailure(m){
          state.placing = false;
          error.log(m);
      },
      expirationNotFound({dispatch}) {
          error.log("No results for options. Reverting to entity");
          dispatch('setSingleEntity')
      },
      ConvertOrderActionToFields: function (v) {
          var effect = 0;
          var side = 0;
          switch (v) {
              case 1:
                  side = OrderAction.Buy;
                  effect = PositionEffect.Open;
                  break; //Buy
              case 2:
                  side = OrderAction.Sell;
                  effect = PositionEffect.Close;
                  break; //Sell To Close
              case 3:
                  side = OrderAction.Sell;
                  effect = PositionEffect.Open;
                  break; //Sell Short
              case 8:
                  side = OrderAction.Buy;
                  effect = PositionEffect.Close;
                  break; //Buy To Cover
          }
          return {effect: effect, side: side};
      },
      SwitchDebitCredit(){
          state.order.DebitCredit = DebitCredit.GetAnother(state.order.DebitCredit)
      },

  },
    getters:{
        InvalidOrder(state) {
                if (state.order.OrderClass === 0 || state.order.OrderType === 0 || state.order.Duration == 0) return true;
                if (isNaN(state.order.Quantity) || state.order.Quantity <= 0) return true;
                if (!state.order.UnderlyingSymbol || state.order.UnderlyingSymbol.length==0) return true;
                if (state.order.Legs[0].AssetType == 0 ||
                    state.order.Legs[0].PositionEffect == 0 ||
                    state.order.Legs[0].Action == 0)
                    return true;


                if (state.order.OrderClass === 2) {
                    if (!DebitCredit.isValid(state.order.DebitCredit)) return true;

                    if (state.order.Legs[1].AssetType == 0 ||
                        state.order.Legs[1].PositionEffect == 0 ||
                        state.order.Legs[1].Action == 0)
                        return true;
                    if (isNaN(state.order.Legs[0].SpreadRatio) || state.order.Legs[0].SpreadRatio <= 0) return true;
                    if (isNaN(state.order.Legs[1].SpreadRatio) || state.order.Legs[1].SpreadRatio <= 0) return true;
                }
                if ((state.order.OrderType === OrderType.Limit || state.order.OrderType === OrderType.StopLimit ) &&
                    (isNaN(state.order.Price) || state.order.Price<=0)
                ) return true;
                if ((state.order.OrderType === OrderType.StopMarket || state.order.OrderType === OrderType.StopLimit ) &&
                    (isNaN(state.order.Stop) || state.order.Stop<=0)) return true;

                //if (!state.quote0) return true;
                return false;
            },
        DebitCreditInvalid(state) {
            return !DebitCredit.isValid(state.order.DebitCredit);
        },
        spread(state){
            return state.order.OrderClass == 2;
        }
    }
}